if (!Array.prototype.at) {
    // eslint-disable-next-line no-extend-native
    Array.prototype.at = function (index) {
        if (index < 0) {
            index = this.length + index
        }

        if (index >= 0 && index < this.length) {
            return this[index]
        }

        return undefined
    }
}
